import { getDateTimeProperties } from 'lib/date'
import { Address, BuyerPaymentType, MainInterests } from 'graphql/types'
import { TGetStepProps, TStep } from './types'
import Schedule from './components/Schedule'
import Form from './components/Form'
import Login from './components/Login'
import Buyer from './components/Buyer'
import Confirmation from './components/Confirmation'
import { stepVisitEvent } from 'pages/imoveis/imovel/events'

export const getSteps = ({
  listing,
  control,
  register,
  setValue,
  watch,
  status,
  setStep,
  profile,
  onSuccessButtonClick,
}: TGetStepProps): Record<number, TStep> => {
  const watchDate = watch('appointment')
  const properties = watchDate?.date
    ? getDateTimeProperties(watchDate?.date)
    : null

  return {
    1: {
      id: 'datePicker',
      content: (
        <Schedule
          setValue={setValue}
          listing={{
            uuid: listing.uuid,
            id: listing.id,
          }}
          value={watch('appointment')}
        />
      ),
    },
    2: {
      id: 'personalInfo',
      content: <Form register={register} control={control} />,
    },
    3: {
      id: 'login',
      content: (
        <Login
          profile={profile}
          phone={watch('phone')}
          onSuccess={(userProfile) => {
            if (userProfile?.id) {
              const {
                id,
                cpf,
                buyerIntent,
                paymentType,
                hasApprovedCredit,
                incomeMonthly,
                creditTotalValue,
                listingAnnounced,
              } = userProfile
              setValue('id', id)
              setValue('cpf', cpf as string)
              setValue(
                'mainInterest',
                buyerIntent?.mainInterest as MainInterests,
              )
              setValue('paymentType', paymentType as BuyerPaymentType)
              setValue('hasApprovedCredit', String(hasApprovedCredit))
              setValue('incomeMonthly', incomeMonthly as string)
              setValue('creditTotalValue', creditTotalValue as string)
              setValue('listingAnnounced', String(listingAnnounced))
              stepVisitEvent({ step: 'buyer' })
              setStep(4)
            }
          }}
          setVisitStep={setStep}
        />
      ),
    },
    4: {
      id: 'buyerInfo',
      content: <Buyer register={register} control={control} />,
    },
    5: {
      id: 'success',
      content: (
        <Confirmation
          profile={profile}
          status={status}
          data={{
            day: properties?.day || '',
            month: properties?.month || '',
            weekDay: properties?.weekFullDay || '',
            hour: properties?.hour || '',
            min: properties?.min || '',
            address: listing.address as Address,
          }}
          setStep={setStep}
          onSuccessButtonClick={onSuccessButtonClick}
        />
      ),
    },
  }
}
